"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = Tooltip;

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "tooltip__Wrapper",
  componentId: "sc-28fulj-0"
})(["display:flex;position:relative;"]);
/**
 * `ElementWrapper` styled component.
 */


var ElementWrapper = _styledComponents["default"].div.withConfig({
  displayName: "tooltip__ElementWrapper",
  componentId: "sc-28fulj-1"
})(["display:inline-block;"]);
/**
 * `PopUp` styled component.
 */


var PopUp = _styledComponents["default"].div.withConfig({
  displayName: "tooltip__PopUp",
  componentId: "sc-28fulj-2"
})(["border-radius:", "px;font-size:10px;line-height:1.2em;min-width:", ";padding:4px 8px;position:absolute;z-index:", ";", " ", " ", ""], (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.prop)('minWidth', 'initial'), (0, _styledTools.theme)('zIndex.tooltip'), (0, _styledTools.ifProp)('inline', (0, _styledComponents.css)(["white-space:nowrap;"]), (0, _styledComponents.css)(["max-width:200px;white-space:no-break;"])), (0, _styledTools.switchProp)('colorTheme', {
  secondary: (0, _styledComponents.css)(["background-color:", ";box-shadow:0 0 4px ", ";color:", ";"], (0, _styles.color)('gray600'), _styles.color.transparentize('black', 0.25), (0, _styles.color)('white')),
  white: (0, _styledComponents.css)(["background-color:", ";box-shadow:0 0 4px ", ";color:", ";"], (0, _styles.color)('white'), _styles.color.transparentize('black', 0.08), (0, _styles.color)('gray600'))
}), (0, _styledTools.switchProp)('placement', {
  bottom: (0, _styledComponents.css)(["left:50%;margin-top:4px;top:100%;transform:translateX(-50%);"]),
  left: (0, _styledComponents.css)(["margin-right:4px;right:100%;top:50%;transform:translateY(-50%);"]),
  right: (0, _styledComponents.css)(["left:100%;margin-left:4px;top:50%;transform:translateY(-50%);"]),
  top: (0, _styledComponents.css)(["bottom:100%;left:50%;margin-bottom:4px;transform:translateX(-50%);"])
}));
/**
 * Export `Tooltip` component.
 */


function Tooltip(props) {
  var children = props.children,
      className = props.className,
      _props$colorTheme = props.colorTheme,
      colorTheme = _props$colorTheme === void 0 ? 'secondary' : _props$colorTheme,
      content = props.content,
      inline = props.inline,
      minWidth = props.minWidth,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'right' : _props$placement;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    onMouseLeave: function onMouseLeave() {
      return setVisible(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(ElementWrapper, {
    className: className,
    onMouseOver: function onMouseOver() {
      return setVisible(true);
    }
  }, children), visible && /*#__PURE__*/_react["default"].createElement(PopUp, {
    colorTheme: colorTheme,
    inline: inline,
    minWidth: minWidth,
    placement: placement
  }, content));
}